module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-06.06d755ee.png";